import { Routes, Route, Navigate } from 'react-router';
import { Home } from './routes/Home';
import { ScanLayout } from './routes/ScanLayout';
import { Executive } from './routes/Executive';
import { DnsPage } from './routes/Dns';
import { EmailPage } from './routes/Email';
import { WebPage } from './routes/Web';
import { SslPage } from './routes/Ssl';
import { VulnPage } from './routes/Vuln';
import { InfraPage } from './routes/Infra';
import { CompliancePage } from './routes/Compliance';
import { SubdomainsPage } from './routes/Subdomains';
import { TechPage } from './routes/Tech';
import { WhoisPage } from './routes/Whois';
import { TermsPage } from './routes/Terms';
import { PrivacyPage } from './routes/Privacy';
import { AupPage } from './routes/Aup';
import { DocsPage } from './routes/Docs';
import { AdminPage } from './routes/Admin';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/aup" element={<AupPage />} />
      <Route path="/docs" element={<DocsPage />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/results" element={<ScanLayout />}>
        <Route index element={<Navigate to="executive" replace />} />
        <Route path="executive" element={<Executive />} />
        <Route path="dns" element={<DnsPage />} />
        <Route path="email" element={<EmailPage />} />
        <Route path="web" element={<WebPage />} />
        <Route path="ssl" element={<SslPage />} />
        <Route path="vuln" element={<VulnPage />} />
        <Route path="infra" element={<InfraPage />} />
        <Route path="compliance" element={<CompliancePage />} />
        <Route path="subdomains" element={<SubdomainsPage />} />
        <Route path="tech" element={<TechPage />} />
        <Route path="whois" element={<WhoisPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
